import React, { useState, useEffect } from 'react'
import { message, Cascader, Modal, Form, Input, Button, Space } from 'antd'
import { infoProvince, provinceResetPassword } from "../../../http/modules/province";
import './index.scss'

export default function HomeProvince() {

    // 机构基本信息
    const [info, setInfo] = useState([])
    // 修改密码
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 机构详情
    const onFinish = async () => {
        try {
            const res = await infoProvince();
            if (res.code == 0) {
                setInfo(res.data)
            }
        } catch (err) {
            message.error(err.response.data?.msg);
        }
    };

    // 修改密码确定
    const handleOk = async (value) => {
        const res = await provinceResetPassword({
            "password1": value.password1,
            "password2": value.password2
        });
        if (res.code == 0) {
            message.success('修改密码成功');
            setIsModalOpen(false);
        } else {
            message.error(res.msg);
        }
    };

    // 修改密码取消
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        onFinish()
    }, [])

    return (
        <div className='homeProvince'>
            <header>
                <p></p>
                账号信息
            </header>
            <main>
                <p>
                    <span>用户名</span>
                    <input disabled type="text" value={info?.provinceAdmin?.loginName || ''} />
                </p>
                <p>
                    <span>单位</span>
                    <input disabled type="text" value={info?.provinceAdmin?.govName || ''} />
                </p>
                <p>
                    <span>地区</span>
                    <input disabled type="text" value={info?.provinceAdmin?.province || ''} />
                </p>
                <p>
                    <span>密码</span>
                    <span className='span1' onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer', fontSize: '18px' }}> 密码重置 </span>
                </p>
            </main>
            <Modal className='modal' closable={false} destroyOnClose={true} bodyStyle={{ paddingLeft: '14%' }} footer={null} title="修改密码" open={isModalOpen} >
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 20,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={handleOk}
                    autoComplete="off"
                >
                    <Form.Item
                        label=""
                        name="password1"
                        rules={[{ required: true, message: '请输入密码!' },
                        {
                            pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{3,200}$/),
                            message: "至少1个大写字母,1个小写字母和1个数字"
                        }
                        ]}
                    >
                        <Input.Password placeholder='请输入新密码' />
                    </Form.Item>

                    <Form.Item
                        label=""
                        name="password2"
                        rules={[
                            {
                                required: true,
                                message: '请再次输入密码',
                            },
                        ]}
                    >
                        <Input.Password placeholder='再次输入新密码' />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            确定
                        </Button>
                        <Button htmlType="button" onClick={handleCancel}>
                            取消
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}
